import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class AudioMeassage {
  loading = false;
  total = 0;
  audiomessageList = [];
  photoFromDb = {};
  rootStore;
  fileUploadUrl = "/Audio/fileupload";

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      audiomessageList: observable,
      photoFromDb: observable,
      loadData: action,
      deleteRecord: action,
      addData: action,
      getAudioMesgData: action,
      setPhotoFromDb: action,
      fileUploadUrl: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, offset, limit }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
    };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("Audio/getAudioMessage", {
        params: postData,
      });

    this.audiomessageList = response?.data?.AudioData;
    this.total = parseInt(response?.data?.AudioData);

    this.loading = false;
  }

  async addData(postData) {
    var audioDetails = { postData };

    // const base64Input = await base64_encode(JSON.stringify(postData));

    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("Audio/uploadAudio", audioDetails);

    return response.data;
  }

  async getAudioMesgData({ id, companyId }) {
    var postData = {
      aId: id,
      companyId: companyId,
      limit: 1,
      offset: 0,
    };
    // console.log(postData)

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("Audio/getAudioMessage", {
        params: postData,
      });

    const singleRow = response?.data?.AudioData[0];
    const fileName = singleRow.path.split("/").pop();
    if (singleRow.path) {
      const fileList = [
        {
          name: fileName,
          status: "success",
          url: config.fleetURL + singleRow.path,
        },
      ];

      this.setPhotoFromDb(fileList);
    }
    return singleRow;

    // return response?.data?.data?.audioMessage[0];
  }

  async setPhotoFromDb(photo) {
    this.photoFromDb = { fileList: photo };
  }

  async deleteRecord({ id }) {
    const postData = {
      id: id,
    };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("Audio/deleteAudio", {
        params: postData,
      });

    return response;
  }
}

export default AudioMeassage;
